module.exports = __webpack_public_path__ + "assets/439dae1b91036fe6f1f679fc9c3e13d2.svg";